export const MemoryCache = {
    customer : null,
    settings : null,
    baseURL : null,
    developerToken : null,
    authorizationToken : null,

    set configs(configs) {
        this.baseURL = configs.base_url;
        this.developerToken = configs.auth_token;
    }
};